import React from 'react';

import {
  Button,
} from '@mui/material';
import { useDispatch } from 'react-redux';

import PdfViewer from '../PdfViewer';

import type { ContentAttachmentJson } from '@/types/domain/notice/valueObjects/contentAttachment';

import { downloadAction } from '@/containers/Main/Content/Notice/thunk';
import { uiSlice } from '@/domain/ui/redux';

/**
 * プロパティ
 */
export type Props = {
  /** 添付 */
  attachment: ContentAttachmentJson,
}

const AttachmentDownloadButton: React.FC<Props> = ({
  attachment,
}) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = React.useState(false);
  const isPdf = attachment.content.indexOf('data:application/pdf') > -1;

  const download = () => {
    downloadAction(attachment);
    dispatch(uiSlice.actions.setMessage({ key: 'info', content: 'ダウンロードフォルダをご確認ください' }));
  };

  return (
    <>
      <Button
        style={{ textTransform: 'none' }}
        onClick={() => {
          if (isPdf) {
            setIsOpen(true);
          } else {
            download();
          }
        }}
      >
        {attachment.name}
      </Button>
      {isPdf && (
        <PdfViewer
          isOpen={isOpen}
          attachment={attachment}
          close={() => setIsOpen(false)}
        />
      )}
    </>
  );
};

export default AttachmentDownloadButton;
